import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const VoucherDetails = lazy(() =>
  import("@scenes/PromotionCodes/components/VoucherDetails").then((module) => ({
    default: module.VoucherDetails,
  }))
);

export const promotionCodeDetailsNRO: NavigationRoutingObject = {
  Component: VoucherDetails,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => {
    return t("promotion-code-details-nro-heading", "Edit Promotion Code");
  },
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/vouchers/vouchers/:appGroupId",
};
